module.exports = __webpack_public_path__ + "static/media/section5.2b1cdb25.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/quiz/image/section5.png
// module id = 301
// module chunks = 0